import { max } from 'lib/array/arrayUtils'
import moment from 'moment'
import { BasicTrip, UserSettings } from 'tripPlanner/types/common'

export function getCanShowTripModule(userSettings: UserSettings | undefined): boolean {
  return !!userSettings && (
    !userSettings.homepageTripModuleDismissedAt ||
    moment(userSettings.homepageTripModuleDismissedAt).add(30, 'days').isBefore(moment())
  )
}

export function getTripToShowOnHomepage(trips: Array<BasicTrip> = []): BasicTrip | undefined {
  // Only consider trips that are not in the past, or have been updated in the last 7 days
  const relevantTrips = trips.filter(trip => (
    !trip.endDate?.isBefore(moment().startOf('day')) ||
    trip.updatedAt.isAfter(moment().subtract(7, 'days'))
  ))

  const candidateTrip = max(relevantTrips, trip => trip.interactedAt.unix())
  const canUseThisTrip = !!candidateTrip && candidateTrip.interactedAt.isAfter(moment().subtract(10, 'days'))

  return canUseThisTrip ? candidateTrip : undefined
}
